module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Code-ea13e258224a9844623a5337e15e6f16.svg";